export default __webpack_public_path__ + "static/media/033-african renaissance monument.6a07860e.svg";